module.exports = __webpack_public_path__ + "img/portfolio-02-670x479.58645418.jpg";